import React, { memo } from 'react';
import cn from 'clsx';
import { ButtonWithGAClickButton, ButtonWithGAClickButtonProps } from '../../button';
import { Card, CardDescription, CardHeader } from '../card';
import {
  signupCard,
  signupCardButton,
  signupCardHeader,
  signupCardLogo,
  signupCardTextWrapper,
} from './signup-card-styles';

type SignupCardProps = {
  className?: string;
  buttonProps: Omit<ButtonWithGAClickButtonProps, 'label' | 'ariaLabel'> & {
    ariaLabel: string;
    label: string;
  };
  description?: string;
  descriptionFormat?: () => React.ReactNode;
  title: string;
  logo: {
    alt: string;
    src: string;
  };
};

/**
 * Вью секции заказа
 */
export const SignupCard: React.FC<SignupCardProps> = memo(
  ({
    className,
    buttonProps: { ariaLabel, label, ...btnProps },
    description,
    descriptionFormat,
    logo,
    title,
  }) => (
    <Card className={cn(signupCard, className)}>
      <div className={signupCardTextWrapper}>
        <CardHeader className={signupCardHeader} variant="h2">
          {title}
        </CardHeader>
        <CardDescription>{descriptionFormat ? descriptionFormat() : description}</CardDescription>
        <ButtonWithGAClickButton
          className={signupCardButton}
          aria-label={ariaLabel}
          {...(btnProps as Omit<ButtonWithGAClickButtonProps, 'label'>)}>
          {label}
        </ButtonWithGAClickButton>
      </div>
      <img
        alt={logo.alt}
        className={signupCardLogo}
        src={logo.src}
        title={logo.alt}
        width={80}
        height={80}
      />
    </Card>
  )
);
